/* import __COLOCATED_TEMPLATE__ from './snooze-conversation.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
import Component from '@glimmer/component';
import { SNOOZED_UNTIL_MAP, DIGITS_ONLY_REGEX } from 'embercom/lib/inbox/constants';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import moment from 'moment-timezone';
import { inject as service } from '@ember/service';

export default class SnoozeConversation extends Component {
  @service appService;
  @service intl;
  @service session;
  @service logService;
  @tracked selectedHours = 24;

  get app() {
    return this.appService.app;
  }

  get snoozeOptions() {
    return SNOOZED_UNTIL_MAP.map((snooze) => {
      snooze.value = this.intl.t(
        `settings.inbox-rules.actions.snooze-conversation.map.${snooze.intlKey}`,
      );
      return snooze;
    });
  }

  get actionData() {
    return this.args.action.actionData;
  }

  get snoozeString() {
    if (this.actionData.snoozed_until) {
      if (this.actionData.snoozed_until === 'hours') {
        return this.intl.t('settings.inbox-rules.actions.snooze-conversation.snoozed-hours', {
          hours: this.actionData.selected_hours,
        });
      }

      return this.snoozeOptions.find((snooze) => snooze.key === this.actionData.snoozed_until)
        .value;
    }
  }

  @action snoozeByHours() {
    if (!DIGITS_ONLY_REGEX.test(this.selectedHours) || this.selectedHours <= 0) {
      this.selectedHours = '';
      return;
    }

    this.args.action.actionData = {
      snoozed_until: 'hours',
      author_timezone: moment.tz.guess(),
      selected_hours: this.selectedHours,
    };

    if (this.onChange) {
      this.onChange();
    }

    this.logService.log({
      log_type: 'rulesActionsSnoozeConversation',
      app_id: this.session.workspace.id,
      admin_id: this.session.teammate.id,
      moment_cache_js_author_timezone: moment.tz.guess(),
      moment_no_cache_js_author_timezone: moment.tz.guess(true),
      browser_author_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
  }

  @action selectSnoozeByIndex(index) {
    this.args.action.actionData = {
      snoozed_until: this.snoozeOptions[index].key,
      author_timezone: moment.tz.guess(),
    };

    if (this.onChange) {
      this.onChange();
    }

    this.logService.log({
      log_type: 'rulesActionsSnoozeConversation',
      app_id: this.session.workspace.id,
      admin_id: this.session.teammate.id,
      snoozed_until: this.snoozeOptions[index].key,
      moment_cache_js_author_timezone: moment.tz.guess(),
      moment_no_cache_js_author_timezone: moment.tz.guess(true),
      browser_author_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
  }
}
